<template>
  <header class="bg-white border-b border-gray-200">
    <div class="container">
      <div class="flex justify-between items-center h-[72px]">
        <router-link to="/" class="flex items-center gap-3">
          <div class="w-9 h-9 bg-primary-600 rounded-lg flex items-center justify-center">
            <span class="text-white font-bold text-base">P</span>
          </div>
          <div class="hidden sm:block leading-tight">
            <h1 class="font-bold text-gray-900 text-base">Pricing Calculator</h1>
            <p class="text-xs text-gray-500">Screen print &amp; embroidery quotes</p>
          </div>
        </router-link>

        <div class="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full" :class="healthPillBg">
          <span class="w-1.5 h-1.5 rounded-full" :class="healthStatusColor"></span>
          <span class="text-xs font-semibold" :class="healthTextColor">{{ healthStatusText }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { healthCheck } from '@/services/api'

const healthStatus = ref('checking')

const healthPillBg = computed(() => ({
  healthy: 'bg-success-50',
  unhealthy: 'bg-error-50',
  checking: 'bg-warning-50'
}[healthStatus.value] || 'bg-gray-100'))

const healthStatusColor = computed(() => ({
  healthy: 'bg-success-500',
  unhealthy: 'bg-error-500',
  checking: 'bg-warning-500'
}[healthStatus.value] || 'bg-gray-400'))

const healthTextColor = computed(() => ({
  healthy: 'text-success-700',
  unhealthy: 'text-error-700',
  checking: 'text-warning-700'
}[healthStatus.value] || 'text-gray-600'))

const healthStatusText = computed(() => ({
  healthy: 'API online',
  unhealthy: 'API offline',
  checking: 'Checking...'
}[healthStatus.value] || 'Unknown'))

const checkHealth = async () => {
  try {
    await healthCheck()
    healthStatus.value = 'healthy'
  } catch {
    healthStatus.value = 'unhealthy'
  }
}

let healthCheckInterval = null

onMounted(() => {
  checkHealth()
  healthCheckInterval = setInterval(checkHealth, 30000)
})

onUnmounted(() => {
  if (healthCheckInterval) clearInterval(healthCheckInterval)
})
</script>
